import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import { createStore } from 'redux';
import rootReducer from './redux/index';
import './i18n';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);

const store = createStore(rootReducer);

// Die Komponente App wird an die index.html 'root' zugewiesen
root.render(

<Provider store = {store}>
  <App/>
</Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
